/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Gmail_ReadInputs */

const es_tools_gmail_read = /** @type {(inputs: Tools_Gmail_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo correo de Gmail...`)
};

const en_tools_gmail_read = /** @type {(inputs: Tools_Gmail_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Gmail message...`)
};

/**
* | output |
* | --- |
* | "Reading Gmail message..." |
*
* @param {Tools_Gmail_ReadInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_gmail_read = /** @type {((inputs?: Tools_Gmail_ReadInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Gmail_ReadInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_gmail_read(inputs)
	return en_tools_gmail_read(inputs)
});
export { tools_gmail_read as "tools.gmail.read" }